.container {
    margin-top: 10px;
}

.filtersLabel {
    font-family: monospace;
    font-weight: 600;
    font-size: 13px;
    color: rgb(96, 94, 92);
}

.resultsCount {
    font-family: monospace;
    font-size: 13px;
    color: rgb(96, 94, 92);
    padding-top: 4px;
}

.clearFiltersButton {
    font-family: monospace;
    padding: 8px 24px;
    background: transparent;
    border: 1.5px solid rgb(0, 120, 212);
    border-radius: 20px;
    color: rgb(0, 120, 212);
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.15s ease;
    text-transform: uppercase;
    align-self: center;
    margin-top: 8px;
}

.clearFiltersButton:hover {
    background: rgba(0, 120, 212, 0.06);
    border-color: rgb(0, 90, 170);
    color: rgb(0, 90, 170);
}
